import { c as _c } from "react/compiler-runtime";
import { Button } from '@/app/components/button';
import { IconArrowBack } from '@/app/components/icons/ui-actions/icon-arrow-back';
import { IconArrowForward } from '@/app/components/icons/ui-actions/icon-arrow-forward';
import { ALLOWED_MEDIA, ResponsiveImage } from '@/app/components/media/app-image';
import { SpartanProductCustomizeBufferedImage } from '@/app/lcv/components/sections/spartan/products/customize/configurator/preview-media/buffered-image';
import { IMAGE_PRELOAD_OFFSET, PREVIEW_DESKTOP_WIDTHS, PREVIEW_IMAGE_PARAMS, PREVIEW_IMAGE_SIZES, PREVIEW_MOBILE_WIDTHS, PREVIEW_NAV_WRAP_CLASS_NAME } from '@/app/lcv/components/sections/spartan/products/customize/configurator/preview-media/preview-carousel/constants';
import type { SpartanProductCustomizePreviewCarouselProps } from '@/app/lcv/components/sections/spartan/products/customize/configurator/preview-media/preview-carousel/types';
import { getPreviewObjectFit, isVehiclePreviewView } from '@/app/lcv/components/sections/spartan/products/customize/configurator/preview-media/utils';
import styles from '@/app/lcv/components/sections/spartan/products/customize/styles.module.css';
import { SPARTAN_PRODUCT_CUSTOMIZE_DATA_GA, SPARTAN_PRODUCT_CUSTOMIZE_TRACKING } from '@/app/lcv/components/sections/spartan/products/customize/tracking';
import { SPARTAN_PRODUCT_ICON_BUTTON_CLASS_NAME } from '@/app/lcv/components/sections/spartan/products/shared/icon-button';
import { SPARTAN_PRODUCTS_EVENT_NAME } from '@/app/lcv/components/sections/spartan/products/shared/tracking';
import arrowStyles from '@/app/lcv/components/sections/spartan/shared/arrow-motion.module.css';
import { SPARTAN_PRODUCT_CUSTOMIZE_LABELS } from '@/app/lcv/contents/spartan/products/shared/customize-common-fields.data';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';
import { stripHtmlTags } from '@/app/utils/format';
export const SpartanProductCustomizePreviewCarousel = t0 => {
  const $ = _c(43);
  const {
    modelLabel,
    previewTone,
    isDarkChrome,
    previewOptions,
    pendingOptions,
    activeView,
    emblaRef,
    isPrevDisabled,
    isNextDisabled,
    onPrev,
    onNext,
    onImageReady,
    onImageError,
    onVehicleSwapStart
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn(styles.previewSurface, "group relative overflow-hidden");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== modelLabel) {
    t2 = stripHtmlTags(modelLabel);
    $[1] = modelLabel;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `${t2} ${SPARTAN_PRODUCT_CUSTOMIZE_LABELS.previewCarousel}`;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = createDataAttributes({
      test: SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.previewSlider
    });
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== activeView || $[5] !== modelLabel || $[6] !== onImageError || $[7] !== onImageReady || $[8] !== onVehicleSwapStart || $[9] !== pendingOptions || $[10] !== previewOptions || $[11] !== previewTone) {
    let t6;
    if ($[13] !== activeView || $[14] !== modelLabel || $[15] !== onImageError || $[16] !== onImageReady || $[17] !== onVehicleSwapStart || $[18] !== pendingOptions || $[19] !== previewOptions.length || $[20] !== previewTone) {
      t6 = (option, index) => {
        const isActive = option.view === activeView;
        const isSurfaceToneHeld = pendingOptions.some(pendingOption => pendingOption.view === option.view && pendingOption.src !== option.src);
        return <li key={option.view} className={cn("relative min-w-0 shrink-0 grow-0 basis-full", option.view === "interior" && "bg-gray-900")} role="group" aria-roledescription="slide" aria-label={SPARTAN_PRODUCT_CUSTOMIZE_LABELS.previewSlide(option.label, index + 1, previewOptions.length)} aria-current={isActive ? "true" : undefined} aria-hidden={isActive ? undefined : true} {...createDataAttributes({
          test: SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.previewSlide(option.view),
          active: isActive ? "true" : null
        })}><SpartanProductCustomizeBufferedImage src={option.src} alt={`${modelLabel} ${option.label}`} width={960} height={540} sizes={PREVIEW_IMAGE_SIZES} mobileWidths={PREVIEW_MOBILE_WIDTHS} desktopWidths={PREVIEW_DESKTOP_WIDTHS} params={PREVIEW_IMAGE_PARAMS} objectFit={getPreviewObjectFit(option.view)} className="aspect-16-9 w-full select-none" surfaceClassName={option.view === "interior" ? "bg-gray-900" : styles.previewSurface} surfaceTone={option.view === "interior" ? undefined : previewTone} fade={false} decoding={isActive ? "sync" : undefined} loading="lazy" preloadOffset={IMAGE_PRELOAD_OFFSET} onImageLoad={() => onImageReady(option)} onImageError={() => onImageError(option)} onSwapStart={isVehiclePreviewView(option.view) && isActive ? onVehicleSwapStart : undefined} swapEffect={isActive ? "surfaceCrossfade" : "none"} holdSurfaceTone={isSurfaceToneHeld} testId={SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.previewImage(option.view)} /></li>;
      };
      $[13] = activeView;
      $[14] = modelLabel;
      $[15] = onImageError;
      $[16] = onImageReady;
      $[17] = onVehicleSwapStart;
      $[18] = pendingOptions;
      $[19] = previewOptions.length;
      $[20] = previewTone;
      $[21] = t6;
    } else {
      t6 = $[21];
    }
    t5 = previewOptions.map(t6);
    $[4] = activeView;
    $[5] = modelLabel;
    $[6] = onImageError;
    $[7] = onImageReady;
    $[8] = onVehicleSwapStart;
    $[9] = pendingOptions;
    $[10] = previewOptions;
    $[11] = previewTone;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[22] !== t5) {
    t6 = <ul className="flex touch-pan-y">{t5}</ul>;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== activeView || $[25] !== onImageError || $[26] !== onImageReady || $[27] !== pendingOptions) {
    t7 = !!pendingOptions.length && <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-0">{pendingOptions.map(option_0 => <ResponsiveImage key={`${option_0.view}:${option_0.src}`} mobileSrc={{
        src: option_0.src,
        media: ALLOWED_MEDIA.lgDown,
        sizes: PREVIEW_IMAGE_SIZES,
        widths: PREVIEW_MOBILE_WIDTHS,
        params: PREVIEW_IMAGE_PARAMS
      }} desktopSrc={{
        src: option_0.src,
        media: ALLOWED_MEDIA.lgUp,
        sizes: PREVIEW_IMAGE_SIZES,
        widths: PREVIEW_DESKTOP_WIDTHS,
        params: PREVIEW_IMAGE_PARAMS
      }} alt="" width={960} height={540} loading="eager" fetchPriority={option_0.view === activeView ? "high" : "low"} objectFit={getPreviewObjectFit(option_0.view)} className="aspect-16-9 absolute inset-0 w-full select-none" fade={false} onLoad={() => onImageReady(option_0)} onError={() => onImageError(option_0)} testId={`${SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.previewImage(option_0.view)}-preload`} />)}</div>;
    $[24] = activeView;
    $[25] = onImageError;
    $[26] = onImageReady;
    $[27] = pendingOptions;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  let t8;
  if ($[29] !== isDarkChrome || $[30] !== isNextDisabled || $[31] !== isPrevDisabled || $[32] !== onNext || $[33] !== onPrev || $[34] !== previewOptions.length) {
    t8 = previewOptions.length > 1 && <>{!isPrevDisabled && <div className={cn(PREVIEW_NAV_WRAP_CLASS_NAME, "left-4 lg:group-hover:pointer-events-auto lg:group-hover:translate-x-0 lg:group-hover:opacity-100 lg:group-has-focus-visible:pointer-events-auto lg:group-has-focus-visible:translate-x-0 lg:group-has-focus-visible:opacity-100 lg:pointer-fine:-translate-x-3")}><Button type="button" aria-label={SPARTAN_PRODUCT_CUSTOMIZE_LABELS.previous} variant="primary" color={isDarkChrome ? "white" : "black"} size="sm" iconBefore={<span className={cn("block size-full", arrowStyles.arrowLeft)}><IconArrowBack /></span>} onClick={onPrev} className={cn(SPARTAN_PRODUCT_ICON_BUTTON_CLASS_NAME, arrowStyles.trigger)} {...createDataAttributes({
          test: SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.previewNavPrev
        })} {...createDataGA({
          eventName: SPARTAN_PRODUCTS_EVENT_NAME,
          group: SPARTAN_PRODUCT_CUSTOMIZE_DATA_GA.section,
          click: true,
          text: SPARTAN_PRODUCT_CUSTOMIZE_LABELS.previous,
          value: SPARTAN_PRODUCT_CUSTOMIZE_DATA_GA.sliderNav
        })} /></div>}{!isNextDisabled && <div className={cn(PREVIEW_NAV_WRAP_CLASS_NAME, "right-4 lg:group-hover:pointer-events-auto lg:group-hover:translate-x-0 lg:group-hover:opacity-100 lg:group-has-focus-visible:pointer-events-auto lg:group-has-focus-visible:translate-x-0 lg:group-has-focus-visible:opacity-100 lg:pointer-fine:translate-x-3")}><Button type="button" aria-label={SPARTAN_PRODUCT_CUSTOMIZE_LABELS.next} variant="primary" color={isDarkChrome ? "white" : "black"} size="sm" iconBefore={<span className={cn("block size-full", arrowStyles.arrow)}><IconArrowForward /></span>} onClick={onNext} className={cn(SPARTAN_PRODUCT_ICON_BUTTON_CLASS_NAME, arrowStyles.trigger)} {...createDataAttributes({
          test: SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.previewNavNext
        })} {...createDataGA({
          eventName: SPARTAN_PRODUCTS_EVENT_NAME,
          group: SPARTAN_PRODUCT_CUSTOMIZE_DATA_GA.section,
          click: true,
          text: SPARTAN_PRODUCT_CUSTOMIZE_LABELS.next,
          value: SPARTAN_PRODUCT_CUSTOMIZE_DATA_GA.sliderNav
        })} /></div>}</>;
    $[29] = isDarkChrome;
    $[30] = isNextDisabled;
    $[31] = isPrevDisabled;
    $[32] = onNext;
    $[33] = onPrev;
    $[34] = previewOptions.length;
    $[35] = t8;
  } else {
    t8 = $[35];
  }
  let t9;
  if ($[36] !== emblaRef || $[37] !== previewTone || $[38] !== t3 || $[39] !== t6 || $[40] !== t7 || $[41] !== t8) {
    t9 = <div className={t1} data-preview-tone={previewTone} ref={emblaRef} role="region" aria-roledescription="carousel" aria-label={t3} {...t4}>{t6}{t7}{t8}</div>;
    $[36] = emblaRef;
    $[37] = previewTone;
    $[38] = t3;
    $[39] = t6;
    $[40] = t7;
    $[41] = t8;
    $[42] = t9;
  } else {
    t9 = $[42];
  }
  return t9;
};